var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, ElementRef, Input } from '@angular/core';
import { LoadingService } from "./loading.service";
var LoadingIndicator = (function () {
    //we probably want a reference to ElementRef here to do some DOM manipulations
    function LoadingIndicator(el, loadingService) {
        this.el = el;
        this.loadingService = loadingService;
        this.isLoading = false;
    }
    LoadingIndicator.prototype.showOrHideLoadingIndicator = function (loading) {
        this.isLoading = loading;
        //if (this.isLoading) this.playLoadingAnimation();
        //else cancel the animation?
    };
    LoadingIndicator.prototype.playLoadingAnimation = function () {
        //this will be your implementation to start the loading animation
    };
    LoadingIndicator.prototype.ngOnInit = function () {
        var _this = this;
        this.isLoading = this.preLoad;
        this.subscription = this.loadingService.loading$.subscribe(function (loading) { _this.showOrHideLoadingIndicator(loading); });
    };
    LoadingIndicator.prototype.ngOnDestroy = function () {
        this.subscription.unsubscribe();
    };
    return LoadingIndicator;
}());
__decorate([
    Input(),
    __metadata("design:type", Boolean)
], LoadingIndicator.prototype, "preLoad", void 0);
LoadingIndicator = __decorate([
    Component({
        selector: 'loading-indicator',
        template: "\n       <div [style.visibility]=\"isLoading ? 'visible': 'hidden'\" class=\"ng2-spinner\">           \n            <img class=\"ng2-spinner-img\" src=\"assets/img/loader.gif\" />\n       </div>\n      ",
    }),
    __metadata("design:paramtypes", [ElementRef, LoadingService])
], LoadingIndicator);
export { LoadingIndicator };
//# sourceMappingURL=loading.indicator.js.map